var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44.0256,
    rx: 8,
    fill: "#CFD2F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0046 21.641C22.5982 21.641 23.1048 21.4297 23.5245 21.007C23.9441 20.5843 24.1539 20.0762 24.1539 19.4826C24.1539 18.8891 23.9426 18.3825 23.5199 17.9628C23.0973 17.5432 22.5891 17.3333 21.9956 17.3333C21.402 17.3333 20.8954 17.5447 20.4757 17.9674C20.0561 18.39 19.8463 18.8982 19.8463 19.4917C19.8463 20.0853 20.0576 20.5919 20.4803 21.0115C20.903 21.4312 21.4111 21.641 22.0046 21.641ZM22.0001 34.0256C18.8668 31.2547 16.5065 28.6705 14.9193 26.2731C13.3322 23.8756 12.5386 21.694 12.5386 19.7282C12.5386 16.9077 13.457 14.5812 15.2937 12.7487C17.1304 10.9162 19.3659 10 22.0001 10C24.6343 10 26.8698 10.9162 28.7065 12.7487C30.5433 14.5812 31.4616 16.9077 31.4616 19.7282C31.4616 21.694 30.6681 23.8756 29.0809 26.2731C27.4937 28.6705 25.1334 31.2547 22.0001 34.0256Z",
    fill: "#0F1CB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/LocationIcon.b2f1bf46371757186bae1762b87b0694.svg";
export { ForwardRef as ReactComponent };